export default {
  name: 'FilePreviewComponent',
  props: {
    file: {
      type: Object,
      default: null
    },
    presigned_url: {
      type: String,
      default: ''
    },
    file_name: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  data: () => ({
    loading: true,
    preview_url: '',
    file_type: '',
    file_extension: '',
    internal_file_name: ''
  }),
  mounted() {
    this.initialize_component();
  },
  methods: {
    initialize_component() {
      // Determine if we have a file object or direct URL
      if (this.file) {
        this.internal_file_name = this.file.name || this.file.file_name || '';
        this.preview_url = this.file.presigned_url || this.file.url || '';
      } else {
        this.internal_file_name = this.file_name;
        this.preview_url = this.presigned_url;
      }

      // Extract file extension and type
      this.extract_file_info();

      // Simulate loading (remove in production)
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    extract_file_info() {
      if (!this.internal_file_name) {
        // Try to extract from URL as fallback
        const url_parts = this.preview_url.split('/');
        this.internal_file_name = url_parts[url_parts.length - 1].split('?')[0];
      }

      // Get file extension
      const name_parts = this.internal_file_name.split('.');
      this.file_extension = name_parts.length > 1 
        ? name_parts[name_parts.length - 1].toLowerCase() 
        : '';

      // Set file type (same as extension for simplicity)
      this.file_type = this.file_extension;
    },

    close_file_preview_modal() {
      this.$emit('close');
    }
  }
};